var _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0052b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.92 100.142c-20.109 26.163-35.272 56.318-44.101 89.077h133.178z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.181 189.219c-8.829-32.758-23.993-62.913-44.101-89.076l-89.075 89.076z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.819 322.784c8.83 32.758 23.993 62.913 44.101 89.075l89.074-89.075z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.858 52.921c-26.163-20.109-56.317-35.272-89.076-44.102v133.177z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.142 459.079c26.163 20.109 56.318 35.272 89.076 44.102v-133.176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.217 8.819c-32.758 8.83-62.913 23.993-89.075 44.101l89.075 89.075z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.783 503.181c32.758-8.83 62.913-23.993 89.075-44.101l-89.075-89.075z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.005 322.784 89.075 89.076c20.108-26.162 35.272-56.318 44.101-89.076z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.833 222.609h-220.44-.001v-220.442c-10.931-1.423-22.075-2.167-33.392-2.167-11.319 0-22.461.744-33.391 2.167v220.44.001h-220.442c-1.423 10.931-2.167 22.075-2.167 33.392 0 11.319.744 22.461 2.167 33.391h220.44.001v220.442c10.931 1.423 22.073 2.167 33.392 2.167 11.317 0 22.461-.743 33.391-2.167v-220.44-.001h220.442c1.423-10.931 2.167-22.073 2.167-33.392 0-11.317-.744-22.461-2.167-33.391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.783 322.784 114.236 114.236c5.254-5.252 10.266-10.743 15.048-16.435l-97.802-97.802h-31.482z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.217 322.784h-.002l-114.235 114.235c5.252 5.254 10.743 10.266 16.435 15.048l97.802-97.804z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.217 189.219v-.002l-114.236-114.237c-5.254 5.252-10.266 10.743-15.048 16.435l97.803 97.803h31.481z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.783 189.219 114.237-114.238c-5.252-5.254-10.743-10.266-16.435-15.047l-97.802 97.803z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/43f5c4b2cf2d83836d41f64d8c8698c0de9e238474.svg";
export { ForwardRef as ReactComponent };